import * as React from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  HStack,
  VStack,
  Heading,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Button,
  SimpleGrid,
  Divider,
} from '@chakra-ui/react';

import { Enums } from 'config/const';
import { Fetch } from 'utils/fetch';
import { Layout } from 'views/components/layout';
import { InlineEditor } from 'views/components/inline_editor';
import { Show as Response } from 'interfaces/api/staffs/show';

export const Show = () => {
  const { id } = useParams<Record<string, string | undefined>>()
  const [response, setResponse] = React.useState<Response | undefined>(undefined);
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    Fetch.get(`staffs/${id}`).then(res => {
      setLoading(false);

      if (res?.error) {
        return false;
      }

      setResponse(res);
    });
  }, [id]);

  return (
    <Layout
      currentNavi='staffs'
      loading={loading}
      name={response?.my?.name}
      avatar={response?.my?.avatar}
    >
      <VStack
        w='full'
        h='full'
        p={3}
      >
        <Card
          w='full'
          h='full'
        >
          <CardHeader>
            <Heading size='md'>{response?.staff?.name ? response.staff.name : 'スタッフ詳細'}</Heading>
            <Divider mt={3} />
          </CardHeader>
          <CardBody>
            {response &&
              <>
                <InlineEditor
                  name='id'
                  value={response.staff.id}
                  title='ID'
                  isReadOnly={true}
                />

                <InlineEditor
                  name='email'
                  value={response.staff.email}
                  title='メールアドレス'
                  isReadOnly={true}
                />

                <InlineEditor
                  name='name'
                  value={response?.staff?.name}
                  title='お名前'
                  isRequired={true}
                  url={`staffs/${id}`}
                />

                <InlineEditor
                  name='status'
                  value={response?.staff?.status}
                  title='状態'
                  isRequired={true}
                  url={`staffs/${id}`}
                  type='enums'
                  enums={Enums['staffs']['status']}
                />
              </>
            }
          </CardBody>

          <CardFooter>
            <Button
              w='full'
              as={Link}
              to='/staffs'
            >
              一覧へ
            </Button>
          </CardFooter>
        </Card>

      </VStack>
    </Layout>
  );
};
